import { Url } from '../../utils/codecUtils';
import { EditDataSource } from '../models/editPages';
import { ProcessingDuration } from '../models/processingDuration';
import {
  editPagesPayloadSchema,
  editPagesResponseSchema,
} from './editPages.schema';

export type EditPagesPayload = {
  delete: Url[];
  edit: {
    annotation?: Url;
    parentPages: { rotationDeg: number; page: Url; deleted?: boolean }[];
    targetQueue: Url;
    documentName?: string;
    values?: Record<string, string>;
  }[];
  move: {
    annotation: Url;
    targetQueue: Url;
  }[];
  stopReviewing: Url[];
  stopParent: boolean;
  processingDuration?: ProcessingDuration;
  editDataSource?: EditDataSource;
};

export type EditPagesResponse = {
  results: { document: Url; annotation: Url }[];
};

export const editPages = (
  parentAnnotationId: number,
  payload: EditPagesPayload
) => {
  return {
    endpoint: `/annotations/${parentAnnotationId}/edit_pages`,
    method: 'POST',
    responseSchema: editPagesResponseSchema,
    payload,
    payloadSchema: editPagesPayloadSchema,
  } as const;
};
